import {useState} from 'react';

import SmbgWrapper from './smbg/SmbgWrapper';
import HypoWrapper from './hypo/HypoWrapper';
import Header from './daySelection/Header';
import {useGet365DayReportData, useReview} from 'hooks/useReport';
import PieChartWrapper from './pieChart/PieChartWrapper';
import {
  BarchartLoading,
  LastItemsLoading,
  PieLoading,
  SMBGLoading,
} from '../Loading';
import {Grid} from '@mui/material';
import {usePatientInfo} from 'hooks/usePatient';
import AlertText from '../alert/AlertText';

function Review(props) {
  const {patientId} = props;
  const [chosen, setChosen] = useState(14);
  const selectedDay = (value) => setChosen(value);

  // const {data, isLoading} = useReport(patientId);
  const results = useReview(patientId, chosen);
  const isLoading = results.some((result) => result.isLoading);
  const {data: reportData} = results[0];
  const {data: hypoData} = results[1];

  const {data: patientInfo} = usePatientInfo(patientId);
  const {isPregnant} = patientInfo || {};

  const {data: report365DayData, fetchStatus} = useGet365DayReportData(
    patientId,
    chosen
  );

  const selectedRangeData =
    +chosen === 365 ? report365DayData : {...reportData?.[chosen]};

  const Loading = () => (
    <Grid item xs={12} sx={{px: '16px'}}>
      <SMBGLoading />
      <Grid
        container
        sx={{
          alignItems: 'flex-start',
          bgcolor: '#EEEEEE',
          borderRadius: '16px',
        }}>
        <PieLoading />
        <BarchartLoading />
      </Grid>
      <LastItemsLoading />
    </Grid>
  );

  const estimateStatus =
    selectedRangeData?.estimateStatus == 2
      ? 'suspictionEstimate'
      : selectedRangeData?.estimateStatus == 3
      ? 'wrongEstimate'
      : null;

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background:
          'linear-gradient(180.06deg, #FFFFFF 0.61%, #F4F4F4 17.88%, #F4F4F4 41.75%)',
      }}>
      <Header selectedDay={selectedDay} />
      <div style={{padding: '0 16px 30px 16px', display: 'grid', gap: '18px'}}>
        <AlertText value={estimateStatus} />
        <AlertText value={isPregnant && 'isPregnant'} />
      </div>
      {isLoading || fetchStatus === 'fetching' ? (
        <Loading />
      ) : (
        <div style={{width: '100%', height: '100%', paddingBottom: '40px'}}>
          <SmbgWrapper selectedRangeData={selectedRangeData} daysAgo={chosen} />
          <PieChartWrapper
            selectedRangeData={selectedRangeData}
            patientId={patientId}
          />
          <HypoWrapper
            selectedRangeData={selectedRangeData}
            patientId={patientId}
            daysAgo={chosen}
            hypoData={hypoData}
          />
        </div>
      )}
    </div>
  );
}

export default Review;
